module.constant('ASEBIOL_CONSTANTS',{
	DATE_BIRT_FORMAT:'YYYY-MM-DD',
	DATE_FORMAT:'dd-MM-yyyy',
	DATE_FORMAT_MOMENT:'DD-MM-YYYY',
	DATETIME_FORMAT: "dd-MM-yyyy'T'HH:mm:ssZ",
	DATETIME_FORMAT_MOMENT:"DD-MM-YYYYTHH:mm:ssZZ",
	REGEX_SIGNED2DECIMAl: /^\-?[0-9]+(\.[0-9]{1,2})?$/,
	REGEX_2DECIMAl: /^[0-9]+(\.[0-9]{1,2})?$/,
	REGEX_3DECIMAl: /^[0-9]+(\.[0-9]{1,3})?$/,
	REGEX_RESULT2DECIMAL: /^(<|>)?(\s)?(\-)?([0-9]+((\.|,)[0-9]{1,2})?)$/ //RECIBE EL FORMATO DE resulado que incluye los signos > y < seguido de un número
});